import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import { usePenilikStatus } from 'app/KinerjaPenilikPegawaiPage/hooks/useSummary'
import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

const PageGuardPelaksanaan = ({ children }) => {
  const router = useRouter()
  const toast = useToast()
  const { isPelaksanaanState, summaryFetchStatus } = usePenilikStatus()

  const isLoading = ['loading', 'idle'].includes(summaryFetchStatus)

  useEffect(() => {
    if (!isLoading && !isPelaksanaanState) {
      toast({ message: 'Pelaksanaan belum dimulai!' })
      router.replace(PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isPelaksanaanState])

  if (isLoading || !isPelaksanaanState) {
    return (
      <div className="flex justify-center mt-10">
        <Spinner />
      </div>
    )
  }

  return <>{children}</>
}

export default PageGuardPelaksanaan
